function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, InjectorHelper, MetadataThunkHelper, SessionSelectors, SubtenantsActions, ThunkHelper } from 'invision-core';
import { buildCustomerRequestObject, buildHierarchyRequestObject } from '../helpers/customer.helper';
import reject from 'ramda/src/reject';
import values from 'ramda/src/values';
export var ANONYMIZE_CUSTOMER = {
  BEGIN: 'ANONYMIZE_CUSTOMER_BEGIN',
  SUCCESS: 'ANONYMIZE_CUSTOMER_SUCCESS',
  FAILURE: 'ANONYMIZE_CUSTOMER_FAILURE'
};
export var anonymizeCustomerPromise = function anonymizeCustomerPromise(dispatch, customerId, immediate) {
  return ThunkHelper(dispatch, values(ANONYMIZE_CUSTOMER), {
    method: 'post',
    url: 'SubscriberManagement/AnonymizeSubscriber',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      AnonymizeImmediately: !!immediate
    }
  });
};
export var anonymizeCustomer = function anonymizeCustomer(customerId, immediate) {
  return function (dispatch) {
    return anonymizeCustomerPromise(dispatch, customerId, immediate);
  };
};
export var CANCEL_ANONYMIZE_CUSTOMER = {
  BEGIN: 'CANCEL_ANONYMIZE_CUSTOMER_BEGIN',
  SUCCESS: 'CANCEL_ANONYMIZE_CUSTOMER_SUCCESS',
  FAILURE: 'CANCEL_ANONYMIZE_CUSTOMER_FAILURE'
};
export var cancelAnonymizeCustomerPromise = function cancelAnonymizeCustomerPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(CANCEL_ANONYMIZE_CUSTOMER), {
    method: 'post',
    url: 'SubscriberManagement/CancelScheduledSubscriberAnonymization',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {}
  });
};
export var cancelAnonymizeCustomer = function cancelAnonymizeCustomer(customerId) {
  return function (dispatch) {
    return cancelAnonymizeCustomerPromise(dispatch, customerId);
  };
};
export var RETRIEVE_CUSTOMER = {
  BEGIN: 'RETRIEVE_CUSTOMER_BEGIN',
  SUCCESS: 'RETRIEVE_CUSTOMER_SUCCESS',
  FAILURE: 'RETRIEVE_CUSTOMER_FAILURE'
};
export var retrieveCustomerPromise = function retrieveCustomerPromise(dispatch, customerId) {
  var $ngRedux = InjectorHelper.getNgReduxService();
  var state = $ngRedux.getState();
  return ThunkHelper(dispatch, values(RETRIEVE_CUSTOMER), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriber',
    headers: _defineProperty(_defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId), ApiConstants.CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, SessionSelectors.LanguageHeaderSelector(state)),
    data: {}
  });
};
export var retrieveCustomer = function retrieveCustomer(customerId) {
  return function (dispatch) {
    return retrieveCustomerPromise(dispatch, customerId);
  };
};
export var CUSTOMER_RESET_PASSWORD = {
  BEGIN: 'CUSTOMER_RESET_PASSWORD_BEGIN',
  SUCCESS: 'CUSTOMER_RESET_PASSWORD_SUCCESS',
  FAILURE: 'CUSTOMER_RESET_PASSWORD_FAILURE'
};

// Session ID header is undefined since the API doesn't accept a session ID
export var customerResetPasswordPromise = function customerResetPasswordPromise(dispatch, subscriberLogin) {
  return ThunkHelper(dispatch, values(CUSTOMER_RESET_PASSWORD), {
    method: 'post',
    url: 'SubscriberManagement/GeneratePassword',
    data: {
      Login: subscriberLogin
    }
  });
};
export var customerResetPassword = function customerResetPassword(subscriberLogin) {
  return function (dispatch) {
    return customerResetPasswordPromise(dispatch, subscriberLogin);
  };
};
export var CUSTOMER_RESET_REVOKED_PASSWORD = {
  BEGIN: 'CUSTOMER_RESET_REVOKED_PASSWORD_BEGIN',
  SUCCESS: 'CUSTOMER_RESET_REVOKED_PASSWORD_SUCCESS',
  FAILURE: 'CUSTOMER_RESET_REVOKED_PASSWORD_FAILURE'
};

// Session ID header is undefined since the API doesn't accept a session ID
export var customerResetRevokedPasswordPromise = function customerResetRevokedPasswordPromise(dispatch, customerId, bypassResetPassword) {
  return ThunkHelper(dispatch, values(CUSTOMER_RESET_REVOKED_PASSWORD), {
    method: 'post',
    url: 'SubscriberManagement/ResetRevokedPassword',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      BypassResetPassword: !!bypassResetPassword
    }
  });
};
export var customerResetRevokedPassword = function customerResetRevokedPassword(customerId, bypassResetPassword) {
  return function (dispatch) {
    return customerResetRevokedPasswordPromise(dispatch, customerId, bypassResetPassword);
  };
};
export var CUSTOMER_RESET_DEVICE_PIN = {
  BEGIN: 'CUSTOMER_RESET_DEVICE_PIN_BEGIN',
  SUCCESS: 'CUSTOMER_RESET_DEVICE_PIN_SUCCESS',
  FAILURE: 'CUSTOMER_RESET_DEVICE_PIN_FAILURE'
};
export var customerResetDevicePinPromise = function customerResetDevicePinPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(CUSTOMER_RESET_DEVICE_PIN), {
    method: 'post',
    url: 'SubscriberManagement/UpdateDevicePin',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var customerResetDevicePin = function customerResetDevicePin(customerId) {
  return function (dispatch) {
    return customerResetDevicePinPromise(dispatch, customerId);
  };
};
export var RETRIEVE_DEVICE_PIN_STATUS = {
  BEGIN: 'RETRIEVE_DEVICE_PIN_STATUS_BEGIN',
  SUCCESS: 'RETRIEVE_DEVICE_PIN_STATUS_SUCCESS',
  FAILURE: 'RETRIEVE_DEVICE_PIN_STATUS_FAILURE'
};
export var retrieveDevicePinStatusPromise = function retrieveDevicePinStatusPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(RETRIEVE_DEVICE_PIN_STATUS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveDevicePinStatus',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveDevicePinStatus = function retrieveDevicePinStatus(customerId) {
  return function (dispatch) {
    return retrieveDevicePinStatusPromise(dispatch, customerId);
  };
};
export var UPDATE_LIFECYCLE_DETAILS = 'UPDATE_LIFECYCLE_DETAILS';
export var updateLifeCycleDetails = function updateLifeCycleDetails(lifeCycleDetails) {
  return {
    type: UPDATE_LIFECYCLE_DETAILS,
    payload: lifeCycleDetails
  };
};
export var UPDATE_SUBSCRIBER = {
  BEGIN: 'UPDATE_SUBSCRIBER_BEGIN',
  SUCCESS: 'UPDATE_SUBSCRIBER_SUCCESS',
  FAILURE: 'UPDATE_SUBSCRIBER_FAILURE'
};
export var updateSubscriber = function updateSubscriber(customer) {
  return function (dispatch) {
    return updateSubscriberPromise(dispatch, customer);
  };
};
export var updateSubscriberPromise = function updateSubscriberPromise(dispatch, customer) {
  return ThunkHelper(dispatch, values(UPDATE_SUBSCRIBER), {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscriber',
    data: Object.assign(buildCustomerRequestObject(customer)),
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customer.Id)
  });
};
export var RESEND_VERIFICATION_EMAIL = {
  BEGIN: 'RESEND_VERIFICATION_EMAIL_BEGIN',
  SUCCESS: 'RESEND_VERIFICATION_EMAIL_SUCCESS',
  FAILURE: 'RESEND_VERIFICATION_EMAIL_FAILURE'
};
export var resendVerificationEmail = function resendVerificationEmail(customerId) {
  return function (dispatch) {
    return resendVerificationEmailPromise(dispatch, customerId);
  };
};
export var resendVerificationEmailPromise = function resendVerificationEmailPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(RESEND_VERIFICATION_EMAIL), {
    method: 'post',
    url: 'SubscriberManagement/ResendSubscriberActivationEmail',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var deleteExternalAuthorizationPromise = function deleteExternalAuthorizationPromise(dispatch, customer, externalAuthorizationId) {
  var newExternalAuths = reject(function (auth) {
    return auth.Id === externalAuthorizationId;
  }, customer.ExternalAuthorizations);
  var newCustomer = customer.merge({
    ExternalAuthorizations: newExternalAuths
  });
  return updateSubscriberPromise(dispatch, newCustomer);
};
export var deleteExternalAuthorization = function deleteExternalAuthorization(customer, externalAuthorizationId) {
  return function (dispatch) {
    return deleteExternalAuthorizationPromise(dispatch, customer, externalAuthorizationId);
  };
};
export var CREATE_CUSTOMER = {
  BEGIN: 'CREATE_CUSTOMER_BEGIN',
  SUCCESS: 'CREATE_CUSTOMER_SUCCESS',
  FAILURE: 'CREATE_CUSTOMER_FAILURE'
};
var CREATE_CUSTOMER_PIN = 'CREATE_CUSTOMER_PIN';
export var createCustomerPromise = function createCustomerPromise(dispatch, customer, additionalOptions) {
  return ThunkHelper(dispatch, values(CREATE_CUSTOMER), {
    method: 'post',
    url: 'SubscriberManagement/CreateSubscriber',
    data: Object.assign(buildCustomerRequestObject(customer), additionalOptions)
  });
};
var updateSubscriberPINPromise = function updateSubscriberPINPromise(dispatch, subscriberPIN, subscriberId) {
  return ThunkHelper(dispatch, CREATE_CUSTOMER_PIN, {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscriberPIN',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: subscriberPIN
  });
};
export var UPDATE_CUSTOMER_BILL_CYCLE = {
  BEGIN: 'UPDATE_CUSTOMER_BILL_CYCLE_BEGIN',
  SUCCESS: 'UPDATE_CUSTOMER_BILL_CYCLE_SUCCESS',
  FAILURE: 'UPDATE_CUSTOMER_BILL_CYCLE_FAILURE'
};
var updateSubscriberBillCyclePromise = function updateSubscriberBillCyclePromise(dispatch, billCycleId, subscriberId) {
  return ThunkHelper(dispatch, values(UPDATE_CUSTOMER_BILL_CYCLE), {
    method: 'post',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    url: 'SubscriberManagement/UpdateSubscriberBillCycle',
    data: {
      BillCycleId: billCycleId
    }
  });
};
export var createCustomer = function createCustomer(customer) {
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return createCustomerPromise(dispatch, customer, additionalOptions);
  };
};
export var updateSubscriberPIN = function updateSubscriberPIN(subscriberPIN, subscriberId) {
  return function (dispatch) {
    return updateSubscriberPINPromise(dispatch, subscriberPIN, subscriberId);
  };
};
export var updateSubscriberBillCycle = function updateSubscriberBillCycle(billCycleId, subscriberId) {
  return function (dispatch) {
    return updateSubscriberBillCyclePromise(dispatch, billCycleId, subscriberId);
  };
};
export var CREATE_EDIT_CUSTOMER_FORM_CHANGED = 'CREATE_EDIT_CUSTOMER_FORM_CHANGED';
export var createEditCustomerFormChanged = function createEditCustomerFormChanged(updatedCustomerModel) {
  return {
    type: CREATE_EDIT_CUSTOMER_FORM_CHANGED,
    payload: updatedCustomerModel
  };
};
export var CLEAR_CREATE_EDIT_CUSTOMER_FORM = 'CLEAR_CREATE_EDIT_CUSTOMER_FORM';
export var clearCreateEditCustomerForm = function clearCreateEditCustomerForm() {
  return {
    type: CLEAR_CREATE_EDIT_CUSTOMER_FORM
  };
};
export var SET_CUSTOMER_CATEGORY = 'SET_CUSTOMER_CATEGORY';
export var setCustomerCategory = function setCustomerCategory(category) {
  return {
    type: SET_CUSTOMER_CATEGORY,
    payload: category
  };
};
export var SET_EDIT_ADDITIONAL_PROPERTY = 'SET_EDIT_ADDITIONAL_PROPERTY';
export var setEditAdditionalProperty = function setEditAdditionalProperty(AdditionalProperties) {
  return {
    type: SET_EDIT_ADDITIONAL_PROPERTY,
    payload: AdditionalProperties
  };
};
export var SET_EDIT_AP_ON_CHANGE = 'SET_EDIT_AP_ON_CHANGE';
export var setEditApOnChange = function setEditApOnChange(id, newValue) {
  return {
    type: SET_EDIT_AP_ON_CHANGE,
    payload: {
      id: id,
      newValue: newValue
    }
  };
};
export var CREATE_HIERARCHY = {
  BEGIN: 'CREATE_HIERARCHY_BEGIN',
  SUCCESS: 'CREATE_HIERARCHY_SUCCESS',
  FAILURE: 'CREATE_HIERARCHY_FAILURE'
};
export var createHierarchyPromise = function createHierarchyPromise(dispatch, customer, additionalOptions) {
  return ThunkHelper(dispatch, values(CREATE_HIERARCHY), {
    method: 'post',
    url: 'SubscriberManagement/CreateHierarchy',
    data: Object.assign(buildHierarchyRequestObject(customer), additionalOptions)
  });
};
export var createHierarchy = function createHierarchy(customer) {
  var additionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return createHierarchyPromise(dispatch, customer, additionalOptions);
  };
};
export var FETCH_SHOPPING_CART = {
  BEGIN: 'FETCH_SHOPPING_CART_BEGIN',
  SUCCESS: 'FETCH_SHOPPING_CART_SUCCESS',
  FAILURE: 'FETCH_SHOPPING_CART_FAILURE'
};
export var FETCH_STORE_ORDER = {
  BEGIN: 'FETCH_STORE_ORDER_BEGIN',
  SUCCESS: 'FETCH_STORE_ORDER_SUCCESS',
  FAILURE: 'FETCH_STORE_ORDER_FAILURE'
};
export var CANCEL_STORE_ORDER = {
  BEGIN: 'CANCEL_STORE_ORDER_BEGIN',
  SUCCESS: 'CANCEL_STORE_ORDER_SUCCESS',
  FAILURE: 'CANCEL_STORE_ORDER_FAILURE'
};
export var CLEAR_SAVED_SHOPPING_CART = {
  BEGIN: 'CLEAR_SAVED_SHOPPING_CART_BEGIN',
  SUCCESS: 'CLEAR_SAVED_SHOPPING_CART_SUCCESS',
  FAILURE: 'CLEAR_SAVED_SHOPPING_CART_FAILURE'
};
export var fetchShoppingCartPromise = function fetchShoppingCartPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(FETCH_SHOPPING_CART), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveShoppingCart',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var clearSavedShoppingCartPromise = function clearSavedShoppingCartPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(CLEAR_SAVED_SHOPPING_CART), {
    method: 'post',
    url: 'SubscriberManagement/UpdateShoppingCart',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      PersistCart: true,
      CombineProducts: false,
      ShoppingCart: {}
    }
  });
};
export var fetchShoppingCart = function fetchShoppingCart(customerId) {
  return function (dispatch) {
    return fetchShoppingCartPromise(dispatch, customerId);
  };
};
var fetchStoreOrderPromise = function fetchStoreOrderPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(FETCH_STORE_ORDER), {
    method: 'post',
    url: 'SubscriberManagement/ResumeStoreOrder',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      RetrievePhysicalInventoryDecisions: false,
      RetrieveServiceAttributes: false
    }
  });
};
export var fetchStoreOrder = function fetchStoreOrder(customerId) {
  return function (dispatch) {
    return fetchStoreOrderPromise(dispatch, customerId);
  };
};
var cancelStoreOrderPromise = function cancelStoreOrderPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, values(CANCEL_STORE_ORDER), {
    method: 'post',
    url: 'SubscriberManagement/CancelStoreReservation',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {}
  });
};
export var cancelStoreOrder = function cancelStoreOrder(customerId) {
  return function (dispatch) {
    return cancelStoreOrderPromise(dispatch, customerId);
  };
};
export var clearSavedShoppingCart = function clearSavedShoppingCart(customerId) {
  return function (dispatch) {
    return clearSavedShoppingCartPromise(dispatch, customerId);
  };
};
export var RESET_CUSTOMER_RECOVERABLE = 'RESET_CUSTOMER_RECOVERABLE';
export var resetCustomerRecoverable = function resetCustomerRecoverable() {
  return {
    type: RESET_CUSTOMER_RECOVERABLE
  };
};
export var SET_IS_EDITING_PROFILE = 'SET_IS_EDITING_PROFILE';
export var setIsEditingProfile = function setIsEditingProfile(newValue) {
  return {
    type: SET_IS_EDITING_PROFILE,
    payload: newValue
  };
};
export var SEND_CONSENT_TERMS = {
  BEGIN: 'SEND_CONSENT_TERMS_BEGIN',
  SUCCESS: 'SEND_CONSENT_TERMS_SUCCESS',
  FAILURE: 'SEND_CONSENT_TERMS_FAILURE'
};
export var sendConsentTermsPromise = function sendConsentTermsPromise(dispatch, email, country) {
  return ThunkHelper(dispatch, values(SEND_CONSENT_TERMS), {
    method: 'post',
    url: 'SubscriberManagement/SendConsentTerms',
    data: {
      ConsentCountry: country,
      EmailAddress: email
    }
  });
};
export var sendConsentTerms = function sendConsentTerms(email, country) {
  return function (dispatch) {
    return sendConsentTermsPromise(dispatch, email, country);
  };
};
export var SET_IS_CONSENT_TERMS_SENT = 'SET_IS_CONSENT_TERMS_SENT';
export var setIsConsentTermsSent = function setIsConsentTermsSent(newValue) {
  return {
    type: SET_IS_CONSENT_TERMS_SENT,
    payload: newValue
  };
};
export var INVALIDATE_CREDIT_CLASSIFICATION = 'INVALIDATE_CREDIT_CLASSIFICATION';
export var invalidateCreditClassification = function invalidateCreditClassification() {
  return {
    type: INVALIDATE_CREDIT_CLASSIFICATION
  };
};
export var fetchSubtenantMetadata = function fetchSubtenantMetadata() {
  return function (dispatch) {
    return MetadataThunkHelper(dispatch, SubtenantsActions.SEARCH_SUBTENANTS_TYPES, {
      method: 'post',
      url: 'Subtenants'
    });
  };
};
export var searchSubtenantsPromise = function searchSubtenantsPromise(dispatch) {
  return ThunkHelper(dispatch, SubtenantsActions.SEARCH_SUBTENANTS_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SearchSubtenants'
  });
};
export var searchSubtenants = function searchSubtenants() {
  return function (dispatch) {
    return searchSubtenantsPromise(dispatch);
  };
};
export var CUSTOMER_WRAP_UP = {
  BEGIN: 'CUSTOMER_WRAP_UP_BEGIN',
  SUCCESS: 'CUSTOMER_WRAP_UP_SUCCESS',
  FAILURE: 'CUSTOMER_WRAP_UP_FAILURE'
};
export var customerWrapUpPromise = function customerWrapUpPromise(dispatch, _ref) {
  var customerId = _ref.customerId,
    reasonId = _ref.reasonId,
    comments = _ref.comments;
  return ThunkHelper(dispatch, values(CUSTOMER_WRAP_UP), {
    method: 'post',
    url: 'SubscriberManagement/SubscriberWrapUp',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Comment: comments,
      ReasonCode: reasonId
    }
  });
};
export var customerWrapUp = function customerWrapUp(customerWrapUpModel) {
  return function (dispatch) {
    return customerWrapUpPromise(dispatch, customerWrapUpModel);
  };
};
export var SET_RELOAD_SUBSCRIBER_STATE_FLAG = 'SET_RELOAD_SUBSCRIBER_STATE_FLAG';
export var setReloadSubscriberStateFlag = function setReloadSubscriberStateFlag(boolean) {
  return {
    type: SET_RELOAD_SUBSCRIBER_STATE_FLAG,
    payload: !!boolean
  };
};
export var VALIDATE_SUBSCRIBER_PIN = {
  BEGIN: 'VALIDATE_SUBSCRIBER_PIN_BEGIN',
  SUCCESS: 'VALIDATE_SUBSCRIBER_PIN_SUCCESS',
  FAILURE: 'VALIDATE_SUBSCRIBER_PIN_FAILURE'
};
export var validateCustomerPin = function validateCustomerPin(customerId, pin) {
  return function (dispatch) {
    return ThunkHelper(dispatch, Object.values(VALIDATE_SUBSCRIBER_PIN), {
      method: 'post',
      url: 'SubscriberManagement/ValidateSubscriberPIN',
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
      data: {
        SubscriberPIN: pin
      }
    });
  };
};
export var SET_SERVICES_AND_OFFERS_SELECTED_TAB = 'SET_SERVICES_AND_OFFERS_SELECTED_TAB';
export var setServiceAndOfferWidgetSelectedTab = function setServiceAndOfferWidgetSelectedTab(tab) {
  return {
    type: SET_SERVICES_AND_OFFERS_SELECTED_TAB,
    payload: tab
  };
};
export var SET_SELECTED_SUBSCRIBER_OFFERING_INSTANCE_ID = 'SET_SELECTED_SUBSCRIBER_OFFERING_INSTANCE_ID';
export var setSelectedOfferingInstanceId = function setSelectedOfferingInstanceId(id) {
  return {
    type: SET_SELECTED_SUBSCRIBER_OFFERING_INSTANCE_ID,
    payload: id
  };
};
export var SET_SELECTED_SUBSCRIBER_HIERARCHY_ID = 'SET_SELECTED_SUBSCRIBER_HIERARCHY_ID';
export var setSelectedCustomerHierarchyId = function setSelectedCustomerHierarchyId(id) {
  return {
    type: SET_SELECTED_SUBSCRIBER_HIERARCHY_ID,
    payload: id
  };
};
export var RETRIEVE_SUBSCRIBER_OFFERING_DETAIL = {
  BEGIN: 'RETRIEVE_SUBSCRIBER_OFFERING_DETAIL_BEGIN',
  SUCCESS: 'RETRIEVE_SUBSCRIBER_OFFERING_DETAIL_SUCCESS',
  FAILURE: 'RETRIEVE_SUBSCRIBER_OFFERING_DETAIL_FAILURE'
};
export var retrieveSubscriberOfferingDetail = function retrieveSubscriberOfferingDetail(customerId, id) {
  var applyFutureGlobalDiscounts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch) {
    return ThunkHelper(dispatch, Object.values(RETRIEVE_SUBSCRIBER_OFFERING_DETAIL), {
      method: 'post',
      url: 'SubscriberManagement/RetrieveSubscriberOfferingDetail',
      headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
      data: {
        ApplyFutureGlobalDiscounts: applyFutureGlobalDiscounts,
        OfferingInstanceId: id,
        IncludePaymentInstrumentAssociations: true
      }
    });
  };
};